<template>
    <el-card shadow="hover">
        <label slot="header">脱敏组件</label>
        <el-divider content-position="left">默认保留第一位 v-model="sensitive"</el-divider>
        <j-sensitive v-model="sensitive.default" />
        <el-divider content-position="left">名字脱敏 type="name" eye</el-divider>
        <j-sensitive type="name" v-model="sensitive.phone" eye />
        <el-divider content-position="left">手机号脱敏 type="phone" eye</el-divider>
        <j-sensitive type="phone" v-model="sensitive.phone" eye />
        <el-divider content-position="left">身份证号脱敏 type="id" eye</el-divider>
        <j-sensitive type="phone" v-model="sensitive.id" eye />
        <el-divider content-position="left">定制规则脱敏 :rule="[2, 6]" 第一位为正数表示正向保留多少位， 第二位为负数表示倒向保留多少位</el-divider>
        <el-input style="width: 120px;" v-model="sensitive.custom" placeholder="脱敏测试" />
        <j-sensitive :rule="[2, 6]" v-model="sensitive.custom" />
        <el-input style="width: 120px;" v-model="sensitive.custom" placeholder="脱敏测试" />
    </el-card>
</template>

<script>
    import JSensitive from "./JSensitive";
    export default {
        components: {
            JSensitive
        },
        data() {
            return {
                sensitive: {
                    default: '默认脱敏文字测试',
                    phone: '13113120861',
                    id: '120110199802094688',
                    name: '张思锐',
                    custom: '123456789'
                }
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
